import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DropdownItem } from './../../components/dropdown/models/dropdown-item.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-unhbottomsheet',
  templateUrl: './unhbottomsheet.component.html',
  styleUrls: ['./unhbottomsheet.component.scss']
})
export class UnhBottomsheetComponent implements OnInit {
  items: DropdownItem[];
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<UnhBottomsheetComponent>
  ) { }

  ngOnInit(): void {
    this._bottomSheetRef.backdropClick().subscribe( () => this._bottomSheetRef.dismiss())
  }
  
  selectOption(option: DropdownItem) {
    this._bottomSheetRef.dismiss(option);
    // this.onOptionSelected.emit();
  }
  unHighilghtItem(option: DropdownItem) {
    // this.onOptionSelected.emit(option);
    this._bottomSheetRef.dismiss(option);
    
  }

  preventClick(e) {
    e.stopPropagation();
    e.preventDefault();
    // this.isOpen = !this.isOpen;
    // this.onOpenChanged.emit(this.isOpen)
    
  }
  closeBottomsheet() {
    this._bottomSheetRef.dismiss()
  }

}
